import React, { useEffect, useState } from 'react';
import MarketStateFilterInput from '@app/model/market_state/input/MarketStateFilterInput';
import { AirportCodeKey, AirportInfo, getAirportCodesForProvider } from '@app/model/market_state/AirportCode';
import { MenuButtonFilterItem } from '@app/component/menu/MenuButtonFilter';
import MenuButtonFilter from '@app/component/menu/MenuButtonFilter';
import CompanyHotelDashboardFilter from '@app/model/company_hotel/settings/CompanyHotelDashboardFilter';
import {
	useMarketStateFilterInputTools
} from '@app/site/secured/rateshopper/rates/provider/useMarketStateFilterInputTools';


type DashboardSelectAirportCodeCheckFilterProps = {
	filter: MarketStateFilterInput;
	onFilter: (filter: MarketStateFilterInput) => void;
};

export const DashboardSelectAirportCodeCheckFilter = React.memo(
	function DashboardSelectAirportCodeCheckFilter({ filter, onFilter }: DashboardSelectAirportCodeCheckFilterProps) {
		const {isDashboardFilterEnabled} = useMarketStateFilterInputTools()
		const providerSupportsFilter = isDashboardFilterEnabled(CompanyHotelDashboardFilter.AIRPORT_CODE);

		const [menuItems, setMenuItems] = useState<MenuButtonFilterItem<string | undefined>[]>([]);


		// Load airport codes based on the selected provider
		useEffect(() => {
			if (filter.provider) {
				const airportCodes = getAirportCodesForProvider(filter.provider);
				if (airportCodes) {
					const entriesArray = Object.entries(airportCodes) as [string, AirportInfo][];
					setMenuItems([{name: 'Hotel Only', value: undefined}, ...entriesArray.map((entry) => {
						const [code, info] = entry;
						return { value: code, name: info.name };
					})]);

				} else {
					setMenuItems([{name: 'Select airport', value: undefined}]);
				}
			}
		}, [filter.provider]);

		const onSelect = (value: AirportCodeKey | undefined) => {
			onFilter({
				...filter,
				airportCode: value,
			});
		};

		return <MenuButtonFilter menuItems={menuItems}
														 selectedValue={filter.airportCode}
														 onSelect={onSelect}
														 menuDescription="Please select the airport"
														 enableSearch
														 searchPlaceholder='Filter airports'
														 disabled={!providerSupportsFilter}/>;

	});
